import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Badge } from 'components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import { blogGenRunsRecent, blogGenRunsStats } from '../../../services/api';
import { errMsg, fmtDate, fmtMs, fmtUsd } from '../generator/util';

const V = { succeeded: 'success', failed: 'destructive', running: 'info', queued: 'secondary', cancelled: 'outline' };

export default function RunsTab() {
  const [runs, setRuns] = useState([]);
  const [stats, setStats] = useState(null);
  useEffect(() => {
    Promise.all([blogGenRunsRecent(), blogGenRunsStats()])
      .then(([r, s]) => { setRuns(r); setStats(s); })
      .catch((e) => toast.error(errMsg(e)));
  }, []);
  const totalCost = (stats?.rows || []).reduce((a, r) => a + (r.cost || 0), 0);
  return (
    <div className="space-y-3">
      {stats && (
        <div className="flex flex-wrap gap-2 text-token-base">
          <Badge variant="outline">Last {stats.days} days</Badge>
          <Badge variant="outline">Total {fmtUsd(totalCost)}</Badge>
          {stats.rows.map((r, i) => (
            <Badge key={i} variant={V[r.status] || 'secondary'}>{r.stage} {r.status}: {r.n} · avg {fmtMs(r.avg_ms)} · {fmtUsd(r.cost)}</Badge>
          ))}
        </div>
      )}
      <div className="overflow-auto rounded-token-large border border-borderGrey bg-white">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>#</TableHead><TableHead>When</TableHead><TableHead>Post</TableHead><TableHead>Stage</TableHead><TableHead>Status</TableHead>
              <TableHead>Model</TableHead><TableHead className="text-right">In / out</TableHead><TableHead className="text-right">Cached</TableHead>
              <TableHead className="text-right">Time</TableHead><TableHead className="text-right">Cost</TableHead><TableHead>Note</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {runs.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{r.id}</TableCell>
                <TableCell className="whitespace-nowrap text-token-base">{fmtDate(r.created_at)}</TableCell>
                <TableCell>{r.post_id ? <Link className="text-primary underline" to={`/blog/generate/${r.post_id}`}>#{r.post_id}</Link> : '–'}</TableCell>
                <TableCell>{r.stage}</TableCell>
                <TableCell><Badge variant={V[r.status] || 'secondary'}>{r.status}</Badge></TableCell>
                <TableCell className="text-token-base">{r.model || '–'}{r.effort ? ` · ${r.effort}` : ''}</TableCell>
                <TableCell className="text-right text-token-base">{r.input_tokens ?? '–'} / {r.output_tokens ?? '–'}</TableCell>
                <TableCell className="text-right text-token-base">{r.cache_read_tokens || 0}</TableCell>
                <TableCell className="text-right text-token-base">{fmtMs(r.latency_ms)}</TableCell>
                <TableCell className="text-right text-token-base">{fmtUsd(r.cost_usd)}</TableCell>
                <TableCell className="max-w-[280px] truncate text-token-base text-muted-foreground" title={r.error || r.progress}>{r.error || r.progress}</TableCell>
              </TableRow>
            ))}
            {runs.length === 0 && <TableRow><TableCell colSpan={11} className="py-6 text-center text-muted-foreground">No runs yet</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
